<template>
<div class="container">
    <nav class="breadcrumb" aria-label="breadcrumb">
        <ol class="breadcrumb-list">
            <!-- 首页 -->
            <li class="breadcrumb-item">
                <router-link to="/"><i class="fas fa-home"></i> 首页</router-link>
            </li>
            
            <!-- 一级分类 -->
            <li class="breadcrumb-item">
                <router-link to="/blog">Blog</router-link>
            </li>
            
            <!-- 当前页面（不加链接，添加 is-active 类） -->
            <li class="breadcrumb-item is-active">
                <span>{{ title }}</span>
            </li>
        </ol>
    </nav>
    
    <div class="header">
        <h1>{{title}}</h1>
        <p>从狂热到务实的进化之路：2026年Web3发展现状与未来展望</p>
    </div>

    <div>
        <div class="section">
            <h2>🌍 Web3的当前发展阶段</h2>
            <div style="height:25px" aria-hidden="true"></div>
            <p>截至2025年，Web3技术已经走过了早期的概念炒作阶段，进入了“务实应用”与“基础设施完善”的关键时期。</p>
            
            <div class="highlight-box">
                <h3>🔑 核心现状：从投机到应用</h3>
                <p>当前Web3的发展呈现出明显的分化特征。一方面，DeFi（去中心化金融）和NFT（非同质化代币）经历了市场周期的洗礼，泡沫逐渐消退，留下了具备真实价值的应用场景；另一方面，基础设施层（Layer 1 & Layer 2）的性能大幅提升，交易速度和成本问题得到了显著改善。</p>
            </div>

            <h3>📊 现状数据概览</h3>
            <div class="trend-grid">
                <div class="trend-card">
                    <div class="trend-icon">⚡</div>
                    <h4>技术成熟度</h4>
                    <p>区块链吞吐量提升至数千TPS，跨链互操作性显著增强。</p>
                </div>
                <div class="trend-card">
                    <div class="trend-icon">👥</div>
                    <h4>用户规模</h4>
                    <p>全球活跃用户突破5亿，应用领域从金融扩展到社交、游戏和身份认证。</p>
                </div>
                <div class="trend-card">
                    <div class="trend-icon">🏛️</div>
                    <h4>监管环境</h4>
                    <p>全球主要经济体正在建立清晰的监管框架，合规化进程加速。</p>
                </div>
            </div>
        </div>

        <div class="section">
            <h2>🚀 未来发展的关键路径</h2>
            <div style="height:25px" aria-hidden="true"></div>
            <p>要实现Web3的全面普及，未来需要在以下几个维度实现突破：</p>

            <h3>1. 用户体验的革命</h3>
            <p>当前Web3最大的门槛在于复杂的操作流程。未来的发展必须聚焦于“无感化”交互，让普通用户无需了解私钥、Gas费等概念就能使用去中心化应用。</p>

            <h3>2. 隐私与安全的平衡</h3>
            <p>随着数据隐私意识的提升，零知识证明（ZKP）等隐私保护技术将成为标配。如何在保证透明可验证的同时保护用户隐私，是未来发展的核心课题。</p>

            <h3>3. 真实价值的创造</h3>
            <p>Web3不能仅停留在代币交易层面，必须与实体经济深度融合。供应链管理、知识产权保护、数字身份认证等领域将是价值落地的重点方向。</p>
        </div>

        <div class="section">
            <h2>🔮 未来趋势预测</h2>
            <div style="height:25px" aria-hidden="true"></div>
            <p>基于当前的技术演进和市场需求，未来Web3将呈现以下趋势：</p>

            <ul>
                <li><strong>模块化区块链：</strong> 将共识、执行、数据可用性等层解耦，实现高度可定制的区块链架构。</li>
                <li><strong>AI与Web3融合：</strong> 去中心化的人工智能训练与推理网络，解决AI的信任和数据归属问题。</li>
                <li><strong>社交代币化：</strong> 社交关系和影响力将被代币化，形成全新的价值分配机制。</li>
                <li><strong>主权身份：</strong> 用户将完全掌控自己的数字身份，不再依赖中心化平台。</li>
            </ul>
        </div>
        <div style="height:25px" aria-hidden="true"></div>
        <div style="height:25px" aria-hidden="true"></div>
        <div class="conclusion">
            <h2>结语</h2>
            <p>Web3的发展不是对Web2的简单颠覆，而是一次价值互联网的重构。从当前的基础设施完善期，到未来的应用爆发期，Web3正在逐步实现“万物皆可通证化”的愿景。未来已来，只是尚未流行。</p>
        </div>
    </div>

    <div class="footer">
        <p>本文仅供技术交流，不构成投资建议</p>
    </div>
    
    
    <div style="height:25px" aria-hidden="true"></div>
    <div style="height:25px" aria-hidden="true"></div>
    <h2>点击下面图片加入，加入RollerCoin，感谢您的认可。👇👇👇</h2>
    <div style="height:25px" aria-hidden="true"></div>
    <!--Start rollercoin.com code-->
    <a href="https://rollercoin.com/?r=lk0qxc8o">
      <img src="https://static.rollercoin.com/static/img/ref/gen2/w970h90.gif" alt="970h90"/>
    </a>
    <!--End rollercoin.com code-->
  </div>
</template>

<script>
export default{
    name: 'WebStatic',
    data(){
        // data 必须是一个函数，以避免多个实例间的数据共享
        return {
            title: 'web3 发展趋势',
            showMessage: true,
            
        }
    },
    methods: {
        // 定义事件处理函数
        updateTitle(newTitle) {
          this.title = newTitle;
        }
    },
    mounted() {
        // 组件挂载到 DOM 后执行
        console.log('组件已挂载');
    }
}
</script>

<style scoped>
.container {
  padding: 20px;
  background-color: #2f3045;
  color: #fff;
  max-width: 1200px;
    margin: 20px auto;
    width: 100%;
    box-sizing: border-box;
}
h2{
    color: #03e1e4;
}
/* 面包屑容器 */
.breadcrumb {
    /* 使用 Flexbox 排列元素 */
    display: flex;
    /* 内边距 */
    padding: 15px 0px;
    margin: 0 auto;
}
/* 列表样式：去除默认的圆点 */
.breadcrumb-list {
    display: flex;
    list-style: none;
    /* 确保列表项之间有间隔 */
    margin: 0;
    padding: 0;
    flex-wrap: wrap; /* 允许换行，防止长路径溢出 */
}

/* 每个层级的样式 */
.breadcrumb-item {
    color: #fff;
    font-size: 14px;
}

/* 链接样式 */
.breadcrumb-item a {
    color: #fff;
    text-decoration: none;
    transition: color 0.2s ease;
}

.breadcrumb-item a:hover {
    color: #fff;
    text-decoration: underline;
}

/* 当前页面（通常是最后一个）的样式 */
.breadcrumb-item.is-active {
    color: #07e1e4;
    font-weight: 500;
}

/* 分隔符：使用伪元素在每个项目后面添加斜杠 */
.breadcrumb-list .breadcrumb-item:not(:last-child)::after {
    content: "/";
    margin: 0 8px;
    color: #fff;
}

/* 隐藏最后一个项目的分隔符 */
.breadcrumb-item.is-active::after {
    display: none;
}

.header {
    background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
    color: white;
    padding: 40px 20px;
    text-align: center;
    border-radius: 0 0 20px 20px;
    margin-bottom: 30px;
}

.header h1 {
    font-size: 2.5em;
    margin-bottom: 10px;
    letter-spacing: 1px;
}

.header p {
    opacity: 0.9;
    max-width: 600px;
    margin: 0 auto;
    font-weight: 300;
}

h3 {
    color: #fff;
    margin-top: 25px;
}

.highlight-box {
    background: #667eea;
    border-left: 4px solid #07e1e4;
    padding: 15px;
    margin: 20px 0;
    border-radius: 0 4px 4px 0;
}

.trend-grid {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
    gap: 20px;
    margin: 30px 0;
}

.trend-card {
    border: 1px solid #07e1e4;
    border-radius: 10px;
    padding: 20px;
    text-align: center;
    transition: transform 0.3s ease;
}

.trend-card:hover {
    transform: translateY(-5px);
    box-shadow: 0 10px 20px rgba(0,0,0,0.1);
}

.trend-icon {
    font-size: 2em;
    margin-bottom: 15px;
    color: var(--primary-color);
}

.conclusion {
    background: linear-gradient(135deg, #667eea, #764ba2);
    color: white;
    padding: 30px;
    border-radius: 10px;
    text-align: center;
}

.conclusion h2 {
    color: white;
    border: none;
}

.footer {
    text-align: center;
    margin-top: 40px;
    font-size: 1.2rem;
    padding: 20px;
}

@media (max-width: 600px) {
    .container { padding: 10px; }
    .header { padding: 30px 15px; }
    .blog-post { padding: 25px 15px; }
    .header h1 { font-size: 2em; }
}


</style>